// Phase 9 /admin — admin landing. Card grid of admin sub-pages.
import { Link } from "react-router-dom";
import {
    Cpu,
    Database,
    FileCode,
    ShieldCheck,
    Users,
} from "lucide-react";
import PageHeader from "@/components/PageHeader";

const CARDS = [
    {
        to: "/admin/tenants",
        label: "Tenants",
        icon: ShieldCheck,
        description: "Tenant directory, subscription grants and expiry windows.",
        testId: "admin-home-card-tenants",
    },
    {
        to: "/admin/users",
        label: "Users",
        icon: Users,
        description: "User directory, role assignment, password resets.",
        testId: "admin-home-card-users",
    },
    {
        to: "/admin/engineering",
        label: "Engineering Settings",
        icon: Cpu,
        description: "Backend self-check, runtime flags, queue depth.",
        testId: "admin-home-card-engineering",
    },
    {
        to: "/admin/training-data",
        label: "Training Data",
        icon: Database,
        description: "Mirror export window + ZIP download.",
        testId: "admin-home-card-training",
    },
    {
        to: "/admin/raw-presets",
        label: "Raw YAML Access",
        icon: FileCode,
        description: "System preset YAML inspector (admin only).",
        testId: "admin-home-card-raw-presets",
    },
];

export default function AdminHomePage() {
    return (
        <div data-testid="admin-home-page">
            <PageHeader
                title="Admin Console"
                subtitle="Operator-only controls. Jump into tenants, users, engineering, training data or raw preset YAML."
            />
            <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
                {CARDS.map((c) => (
                    <Link
                        key={c.to}
                        to={c.to}
                        className="rounded-lg border border-ux-border-1 bg-ux-bg-1 p-4 hover:border-ux-accent/40 hover:bg-ux-bg-2 transition-colors"
                        data-testid={c.testId}
                    >
                        <c.icon className="w-5 h-5 text-ux-accent mb-2" />
                        <div className="text-[14px] text-ux-text-1 font-medium">
                            {c.label}
                        </div>
                        <div className="text-[12px] text-ux-text-3 mt-1">
                            {c.description}
                        </div>
                    </Link>
                ))}
            </div>
        </div>
    );
}
